import PropTypes from 'prop-types'
import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const FontColorIcon = (props) => {
  return (
    <svg
      className={rootClassName}
      viewBox='-52 -80 299 372'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='FontIcon' transform='translate(-54.312 -18.401)'>
        <path
          id='font'
          d='M138.413,115.249l10.334-11.184L113.233,5h-30.9L5.1,221.266H36l22.09-61.79h45.462a377.317,377.317,0,0,1,34.8-44.227Zm-40.627-67,28.732,80.327h-57.4Z'
          transform='translate(49.212 13.401)'
        />
        <path
          style={{ transition: 'fill 0.3s ease' }}
          id='gota'
          d='M164.359,667.843s-56.5,60.465-56.5,97.671,29.513,58.036,56.5,58.036,57.311-20.5,57.311-58.036S164.359,667.843,164.359,667.843Z'
          transform='translate(46 -519)'
          fill={props.gota ? props.gota : 'currentColor'}
        />
      </g>
    </svg>
  )
}

FontColorIcon.propTypes = {
  gota: PropTypes.string
}
